import { createClient } from '@supabase/supabase-js';
import { config } from './envConfig';

// ⚡ UPDATED: Changed storage key to force fresh connection
// This will clear all cached auth data and force reconnect to production
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: {
    storageKey: 'foodline-main-auth-v2',  // Changed from 'foodline-main-auth'
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Debug: Log the active connection
console.log('🔗 Supabase connected to:', config.supabaseUrl);
